import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { set_page_refresh } from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";


const AddCategory = () => {
  const dispatch = useDispatch()
  const [category, setCategory] = useState({})
  const closeRef = useRef(null)
  // const route = all_routes;
  
  const l = useSelector((state) => state.language || "en");
  const t = useSelector((state) => state.translation || "en");
  const submit= async (event) => {
    const form = event.currentTarget;
    event.preventDefault()
    event.stopPropagation()
    try {
      if(form?.checkValidity()) {

        let res = await axios.post('addcategory/', category)
        console.log(res)
        dispatch(set_page_refresh("categorylist"))
        closeRef.current?.click()
      }
    } catch(e) {
      console.log(e)
      return false;
    }
    

    return false;
  }
  const handleInputChange = (e) => {
    console.log(e)
    const { name, value } = e.target;
    setCategory(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  useEffect(() => {
    const handleHidden = () => {
      // Reset the form state when the modal is hidden
      setCategory({});
    };

    const modalElement = document.getElementById('add-category2');
    modalElement?.addEventListener('hidden.bs.modal', handleHidden);

    return () => {
      modalElement?.removeEventListener('hidden.bs.modal', handleHidden);
    };
  }, []);
  return (
    <>
      {/* Add Category */}
      <div className="modal fade" id="add-category2">
        <div className="modal-dialog modal-dialog-centered custom-modal-two">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>{t?.[l]?.["add_new_category"] || "Add New Category"}</h4>
                  </div>
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeRef}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body custom-modal-body">
                  <form onSubmit={submit}>
                    <div className="mb-3">
                      <label className="form-label">{t?.[l]?.["name"] || "Name"}</label>
                      <input type="text" className="form-control" required 
                      name="name" 
                      value={category.name || ''} 
                      onChange={handleInputChange}/>
                    </div>
                    <div className="modal-footer-btn">
                      <Link
                        to="#"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        {t?.[l]?.["cancel"] || "Cancel"}
                      </Link>
                      <button type="submit" className="btn btn-submit">
                        {t?.[l]?.["save"] || "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Category */}
    </>
  );
};

export default AddCategory;
